import i18n from "@/i18n";

// 提问类型
export const questionTypeOptions = () => [
    {
        label: i18n.t("zhiji.robotLog.queryType"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.robotLog.initQues"),
        value: "initQues"
    },
    {
        label: i18n.t("zhiji.robotLog.byTyping"),
        value: "input"
    },
    {
        label: i18n.t("zhiji.robotLog.byClick"),
        value: "click"
    }
];
